import LazyLoad from 'react-lazyload';
import { images } from '../../../Constants/ImageUrls';
import { convertPrice } from '../../../Utils/ForeignUtils';
import { showCodTrustElement } from '../../../Utils/productPageUtils';

export default function TrustTypeNonReturn({ productId }) {
  const { price: delivPrice, symbol } = convertPrice(499);
  return (
    <>
      <div className="returnRefund" data-type="returnrefund">
        <LazyLoad once offset={100}>
          <img src={images.non_refund} alt="" />
        </LazyLoad>

        <p data-type="returnrefund">Quick Customer Support</p>
      </div>
      {showCodTrustElement(productId) && (
        <div className="returnRefund">
          <LazyLoad once offset={100}>
            <img src="/images/deliveryblack.svg" alt="" />
          </LazyLoad>
          <p>Pay Cash on Delivery</p>
        </div>
      )}
      <div className="returnRefund">
        <LazyLoad once offset={100}>
          <img src="/images/freedeliveryblack.svg" alt="" />
        </LazyLoad>
        <p>
          FREE Delivery above {symbol}
          {delivPrice}
        </p>
      </div>
    </>
  );
}
